export default __webpack_public_path__ + "static/media/mod05.eab3e4c9.svg";